import { ref } from '@vue/composition-api';

export const helpDialog = ref(false);
export const reportIssuesDialog = ref(false);
export const modelStatisticsDialog = ref(false);
export const devModelStatisticsDialog = ref(false);
